// extracted by mini-css-extract-plugin
export default {"componentWrapper":"FormElement_componentWrapper__zfSas","formElementHalfWidth":"FormElement_formElementHalfWidth__49ve3"};